export default __webpack_public_path__ + "static/media/background.5b42fc70.png";